import { Box, Checkbox, Grid, Typography } from '@material-ui/core'
import { AggregatedInventoryArticle, generateArticleKey } from 'shared'
import { getProductImageUrl } from 'utils/imageUtils'
import { DiffAttributesDiv } from './DiffAttributesDiv'

interface DiffCellProps {
  side: string
  index: number
  row: AggregatedInventoryArticle
  iconHeight: string
  itemsPerPage: number
  currentPage: number
  isCellDisabled: (row: AggregatedInventoryArticle, index: number, side: string) => boolean
  handleCheckChange: (row: AggregatedInventoryArticle, index: number, side: string) => void
}

export const DiffCell = ({
  side,
  index,
  row,
  iconHeight,
  itemsPerPage,
  currentPage,
  isCellDisabled,
  handleCheckChange,
}: DiffCellProps): JSX.Element => {
  const id = `diffCell_${side}_${index}`
  const aggregatedArticleKey = generateArticleKey(row)

  return (
    <Box
      data-testid={id}
      key={`${side}_${aggregatedArticleKey}_${index + itemsPerPage * (currentPage - 1)}`}
      className={isCellDisabled(row, index, side) ? 'diffCellDisabled' : 'diffCell'}
      onClick={() => handleCheckChange(row, index, side)}
      style={{
        backgroundColor: `${index % 2 === 0 ? '#d9e6f5' : '#0d71c345'}`,
      }}
    >
      <Grid container>
        <Grid item xs={2}>
          <Box>
            <img width="62px" src={getProductImageUrl(row.card?._id)} />
          </Box>
        </Grid>
        <Grid item xs={9} style={{ position: 'relative' }}>
          <Box>
            <Box data-testid={`${id}_name`}>
              <Typography variant="body1">
                <b>{row.card?.name}</b>
              </Typography>
            </Box>
            <Box data-testid={`${id}_expansion`}>
              <Typography variant="body2">{row.card?.expansion}</Typography>
            </Box>
          </Box>

          {/* <DiffAttributesGrid row={row} iconHeight={iconHeight} /> */}
          {/* <DiffAttributesFlex row={row} iconHeight={iconHeight} /> */}
          <DiffAttributesDiv id={id} row={row} iconHeight={iconHeight} />
        </Grid>
        <Grid item xs={1}>
          <Box marginTop="60px">
            <Checkbox
              data-testid={`${id}_checkbox`}
              checked={row.isSelectedForConflictResolution}
            />
          </Box>
        </Grid>
      </Grid>

      {/* <Box display="flex">
        <Box margin={1}>
          <img
            width="62px"
            src={getProductImageUrl(row.card?._id)}
          />
        </Box>
        <Box>
          <Box>
            <Typography variant="body1">
              <b>{row.card?.name}</b>
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2">{row.card?.expansion}</Typography>
          </Box>

          <DiffAttributes row={row} iconHeight={iconHeight} />
        </Box>
        <Box>
          <Box height="30px">
            <Checkbox checked={row.isSelectedForConflictResolution} />
          </Box>
          <Box>&nbsp;</Box>
        </Box>
      </Box>*/}
    </Box>
  )
}
